import { FC, ReactElement, useEffect } from 'react';
import { useFireEvent } from 'hooks/useFireEvent';
import { StepViewerEvents } from 'constants/app/eventbus-events';

type StepViewerLazyLoaderProps = {
  children: ReactElement;
  eventId?: string;
};

export const StepViewerLazyLoader: FC<StepViewerLazyLoaderProps> = ({
  children,
  eventId
}) => {
  const { fireEvent } = useFireEvent();
  useEffect(() => {
    fireEvent({
      key: StepViewerEvents.DisableControls,
      id: eventId
    });

    return () => {
      fireEvent({
        key: StepViewerEvents.EnableControls,
        id: eventId
      });
    };
  }, []);

  return children;
};
